var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 15 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#52c0a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.809 13.125H3.19c-.726 0-1.316-.59-1.316-1.316V3.19c0-.726.59-1.316 1.316-1.316h8.618c.726 0 1.316.59 1.316 1.316v8.618c0 .726-.59 1.316-1.316 1.316zM3.19 2.754a.437.437 0 00-.437.437v8.618c0 .242.195.437.437.437h8.618a.437.437 0 00.437-.437V3.19a.437.437 0 00-.437-.437zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.762 4.902L6.547 8.801l-1.32-1.504a.553.553 0 00-.403-.195.56.56 0 00-.418.156.612.612 0 00-.187.418.604.604 0 00.152.433l1.762 2.008c.054.063.12.11.195.145a.54.54 0 00.234.05h.008a.566.566 0 00.43-.21l3.64-4.418a.57.57 0 00.11-.204.598.598 0 00-.031-.46.564.564 0 00-.336-.301.569.569 0 00-.227-.032.595.595 0 00-.219.067.533.533 0 00-.175.148zm0 0"
  }))));
}

export default SvgCheckboxChecked;